import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { components } from '@/api/types'

export const RATE_LIMITS_QUERY_KEY = ['admin', 'rate-limits'] as const

/**
 * Egy katalógus-sor — a backend OpenAPI-ból generált típus
 * (`components.schemas.RateLimitRow`, Phase 33.4 / DEC-RATE-001).
 */
export type RateLimitRow = components['schemas']['RateLimitRow']

/**
 * `GET /admin/rate-limits` (Phase 33.4 / DEC-RATE-001).
 *
 * Read-only feed of the backend's per-endpoint rate-limit catalogue +
 * the adaptive HumanPaceMiddleware thresholds. Single source of truth
 * lives in `igazirandi-backend/config/rate_limits.php`; the admin UI
 * renders the response as a table for operators to review.
 */
export function useRateLimits() {
  return useQuery({
    queryKey: RATE_LIMITS_QUERY_KEY,
    queryFn: async (): Promise<RateLimitRow[]> => {
      const { data, error } = await apiClient.GET('/admin/rate-limits')
      if (error) throw error
      return data?.data ?? []
    },
  })
}
